import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Container from '../hoc/Container';
import backendApiService from '../service/backend-api.service';
import { useAccount } from './AccountContext';
import { OrderKeys, formatOrderAmount } from './AccountOrders';
import AccountOrderItems from './AccountOrderItems';

function safePaymentUrl(value) {
  try { const url = new URL(value); return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : null; }
  catch { return null; }
}

export default function AccountOrderPage() {
  const { shop, billId } = useParams();
  const { account, loading: accountLoading, setAccount } = useAccount();
  const [state, setState] = useState({ loading: true, order: null, error: '', scope: '' });
  const scope = `${account?.email || ''}:${shop}:${billId}`;
  const [attempt, setAttempt] = useState(0);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, order: null, error: '', scope });
    if (!account) return () => { cancelled = true; };
    backendApiService.getBotAccountOrder(shop, billId).then(order => {
      if (!cancelled) setState({loading: false, order, error: order ? '' : 'Заказ не найден.', scope});
    }).catch(error => {
      if (cancelled) return;
      if (error.status === 401) setAccount(null);
      setState({loading: false, order: null, error: error.message, scope});
    });
    return () => { cancelled = true; };
  }, [shop, billId, account, setAccount, attempt, scope]);
  const order = state.scope === scope ? state.order : null;
  useEffect(() => {
    if (order?.status !== 'pending' || !order.paymentExpiresAt) return undefined;
    const deadline = Date.parse(order.paymentExpiresAt);
    if (!Number.isFinite(deadline) || deadline <= now) return undefined;
    const timer = window.setTimeout(() => setNow(Date.now()), Math.min(deadline - now + 1, 60 * 60 * 1000));
    return () => window.clearTimeout(timer);
  }, [order, now]);
  const payUrl = order?.status === 'pending' && (!order.paymentExpiresAt || Date.parse(order.paymentExpiresAt) > Math.max(now, Date.now())) ? safePaymentUrl(order.paymentUrl) : null;
  return <Container><section className="content-block mb-2">
    <nav className="other-store-breadcrumb"><Link to="/account" className="other-store-breadcrumb-link">Кабинет</Link><span>/</span><span>Заказ</span></nav>
    <div className="other-store-order-card account-card">
      <h1 className="other-store-title account-title">Ваш заказ</h1>
      {accountLoading ? <p className="other-store-codes-status">Загрузка…</p> : !account ? <p className="other-store-description">Для просмотра заказа <Link to="/account" className="account-link-btn">войдите в кабинет</Link>.</p> : <>
        {state.loading ? <p className="other-store-codes-status">Загружаем заказ…</p> : null}
        {state.scope === scope && state.error ? <p className="other-store-error" role="alert">{state.error} <button className="account-link-btn" onClick={() => setAttempt(value => value + 1)}>Повторить</button></p> : null}
        {order ? <>
          <AccountOrderContent order={order} onUnauthorized={() => setAccount(null)}/>
        </> : null}
      </>}
      <AccountOrderActions payUrl={account && !accountLoading ? payUrl : null} />
    </div>
  </section></Container>;
}

export function AccountOrderActions({backTo='/account',payUrl,readOnly=false}) {
  const target = !readOnly && safePaymentUrl(payUrl);
  return <div className="account-order-detail-actions">
    {target ? <a href={target} className="account-secondary-btn" rel="noopener noreferrer">Перейти к оплате</a> : null}
    <Link to={backTo} className="account-link-btn">← Все заказы</Link>
  </div>;
}

export function AccountOrderContent({order,onUnauthorized}) {
  return <>
          <div className="account-order-head"><span className="account-order-date">{new Date(order.createdAt).toLocaleDateString('ru-RU')}</span><span className={`account-order-status account-order-status--${order.status}`}>{order.statusLabel}</span></div>
          <p className="account-order-source">{order.shopLabel} · {order.channelLabel}</p>
          <AccountOrderItems items={order.items || []} />
          <p className="account-order-amount my-4"><span>Сумма заказа: </span><span>{formatOrderAmount(order)}</span></p>
          {order.status === 'ready' ? <><h2 className="other-store-purchase-title">Ваши коды</h2><OrderKeys order={order} onUnauthorized={onUnauthorized} /></> : null}
          {order.status === 'processing' ? <p className="other-store-description">Оплата получена. Готовим ваш заказ.</p> : null}
          {order.status === 'pending' && order.paymentExpiresAt ? <p className="account-order-deadline">Оплатить до {new Date(order.paymentExpiresAt).toLocaleString('ru-RU')}</p> : null}
          {order.status === 'unpaid' ? <p className="other-store-description">Срок оплаты истёк или заказ отменён. Чтобы купить, оформите заказ заново.</p> : null}
  </>;
}
